import React from "react";
import { LogIn } from "lucide-react";

export default function AzureVDLandingPage() {
  return (
    <div className="min-h-screen font-sans text-[#003366] bg-white">
      <header className="w-full bg-white border-b border-gray-200 py-4 px-6 shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <img
            src="images.png"
            alt="C. Steinweg Group Logo"
            className="h-10"
          />
          <nav className="space-x-6 text-sm font-medium text-[#003366]">
            <a href="https://www.steinweg.com/" className="hover:text-[#00529c]">Home</a>
            <a href="https://www.steinweg.com/history/" className="hover:text-[#00529c]">About</a>
            <a href="https://support.steinweg.com/" className="hover:text-[#00529c]">Support</a>
          </nav>
        </div>
      </header>

      <main className="flex flex-col items-center justify-center py-16 px-4 bg-[#f2f2f2]">
        <div className="w-full max-w-4xl bg-white shadow-md rounded-md border border-gray-300 p-12 space-y-10">
          <img
            src="/5.jpg"
            className="w-full h-64 md:h-80 object-cover rounded-t-md shadow-sm"
          />
          <h1 className="text-4xl font-light text-center tracking-wide">
            Modern Desktop Access
          </h1>
          <p className="text-center text-gray-600 text-lg">
            Secure access to your digital workspace — anytime, anywhere.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <a
              href="https://apps.microsoft.com/store/detail/windows-app/9n1f85v9t8bn"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex justify-center"
            >
              <div className="w-full max-w-xs h-14 flex items-center justify-center bg-black rounded">
                <img
                  src="https://get.microsoft.com/images/en-us%20dark.svg"
                  alt="Download on Microsoft Store"
                  className="h-10"
                />
              </div>
            </a>
            <a
              href="https://apps.apple.com/app/microsoft-remote-desktop/id1295203466"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex justify-center"
            >
              <div className="w-full max-w-xs h-14 flex items-center justify-center bg-black rounded">
                <img
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-mac-app-store/black/en-us"
                  alt="Download on the Mac App Store"
                  className="h-10"
                />
              </div>
            </a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-6">
            <a
              href="https://client.wvd.microsoft.com/arm/webclient/index.html"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <button className="w-full px-6 py-3 text-base font-normal bg-[#003366] text-white hover:bg-[#002244] rounded-none flex items-center justify-center">
                <LogIn className="mr-2 h-5 w-5" /> AVD Portal
              </button>
            </a>
            <a
              href="https://aka.ms/devbox-portal"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <button className="w-full px-6 py-3 text-base font-normal bg-[#003366] text-white hover:bg-[#002244] rounded-none flex items-center justify-center">
                <LogIn className="mr-2 h-5 w-5" /> DevBox Portal
              </button>
            </a>
            <a
              href="https://windows365.microsoft.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <button className="w-full px-6 py-3 text-base font-normal bg-[#003366] text-white hover:bg-[#002244] rounded-none flex items-center justify-center">
                <LogIn className="mr-2 h-5 w-5" /> Windows 365
              </button>
            </a>
          </div>
        </div>
      </main>

      <footer className="w-full bg-white border-t border-gray-200 text-center text-sm text-[#666] py-4">
        &copy; {new Date().getFullYear()} C. Steinweg Group. All rights reserved.
      </footer>
    </div>
  );
}
